import { useAppSelector } from "../redux"

export const useSelectedVariant = () => {
  const selectedVariantId = useAppSelector(state => state.product.productDetailState.selectedVariantId)
  const product = useAppSelector(state => state.product.product_no_design.data)
  return product.variants?.find(variant => `${variant.id}` === `${selectedVariantId}`) || (product.variants || [])[0]
}